module.exports = __webpack_public_path__ + "img/serv_sub1_1_w.9ad93e0a.jpg";